<template>
  <div class="about-us-page">
    <NavBar active-page="about" />
    
    <div class="about-us-container">
      <!-- 当只有一篇文章时直接显示文章内容 -->
      <div v-if="articles.length === 1 && !isListView">
        <h1 class="page-title">{{ articles[0].title }}</h1>
        <p class="article-date text-center">发布日期: {{ formatDate(articles[0].createdAt) }}</p>
        
        <div class="single-article-content" v-html="singleArticleContent"></div>
      </div>
      
      <!-- 有多篇文章或强制显示列表视图时显示文章列表 -->
      <div v-else>
        <h1 class="page-title">了解我们</h1>
        
        <div class="articles-list" v-if="articles.length > 0">
          <div v-for="article in articles" :key="article.id" class="article-item" @click="viewArticle(article)">
            <h3>{{ article.title }}</h3>
            <p class="article-date">发布日期: {{ formatDate(article.createdAt) }}</p>
          </div>
        </div>
        
        <div v-else class="no-articles">
          <p>暂无文章</p>
        </div>
      </div>
      
      <div v-if="selectedArticle" class="article-modal">
        <div class="article-modal-content">
          <span class="close-btn" @click="closeArticle">&times;</span>
          <h2>{{ selectedArticle.title }}</h2>
          <p class="article-date">发布日期: {{ formatDate(selectedArticle.createdAt) }}</p>
          <div class="article-content" v-html="selectedArticle.content"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import NavBar from '@/components/NavBar.vue'

export default {
  name: 'AboutUs',
  components: {
    NavBar
  },
  data() {
    return {
      articles: [],
      selectedArticle: null,
      singleArticleContent: '',
      isListView: false // 用于控制是否强制显示列表视图
    }
  },
  created() {
    this.fetchArticles()
    
    // 检查URL参数是否有文章ID
    const articleId = new URLSearchParams(window.location.search).get('article')
    if (articleId) {
      this.fetchArticleById(articleId)
      this.isListView = true // 如果通过URL参数访问特定文章，显示列表视图
    }
    
    // 检查URL参数是否指定显示列表
    const viewMode = new URLSearchParams(window.location.search).get('view')
    if (viewMode === 'list') {
      this.isListView = true
    }
  },
  methods: {
    async fetchArticles() {
      try {
        const response = await axios.get('/api/articles')
        this.articles = response.data
        
        // 如果只有一篇文章，自动获取其完整内容
        if (this.articles.length === 1 && !this.isListView) {
          this.fetchSingleArticleContent(this.articles[0]._id || this.articles[0].id)
        }
      } catch (error) {
        console.error('获取文章失败:', error)
      }
    },
    async fetchSingleArticleContent(id) {
      try {
        const response = await axios.get(`/api/articles/${id}`)
        this.singleArticleContent = response.data.content
      } catch (error) {
        console.error('获取单篇文章内容失败:', error)
      }
    },
    async viewArticle(article) {
      try {
        // 获取完整文章内容
        const response = await axios.get(`/api/articles/${article._id || article.id}`)
        this.selectedArticle = response.data
      } catch (error) {
        console.error('获取文章详情失败:', error)
        // 如果获取失败，仍使用列表中的文章信息
        this.selectedArticle = article
      }
    },
    async fetchArticleById(id) {
      try {
        const response = await axios.get(`/api/articles/${id}`)
        this.selectedArticle = response.data
      } catch (error) {
        console.error('通过ID获取文章失败:', error)
      }
    },
    closeArticle() {
      this.selectedArticle = null
    },
    formatDate(dateString) {
      const date = new Date(dateString)
      return date.toLocaleDateString('zh-CN')
    }
  }
}
</script>

<style scoped>
.about-us-page {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #fff;
}

.about-us-container {
  flex: 1;
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
}

.page-title {
  text-align: center;
  margin-bottom: 30px;
  color: #333;
}

.articles-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
}

.article-item {
  border: 1px solid #eee;
  border-radius: 5px;
  padding: 15px;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.article-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.article-date {
  color: #888;
  font-size: 0.9em;
}

.no-articles {
  text-align: center;
  color: #888;
  margin-top: 50px;
}

.article-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
  box-sizing: border-box;
}

.article-modal-content {
  background-color: white;
  padding: 40px;
  border-radius: 8px;
  max-width: 900px;
  width: 100%;
  max-height: 85vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 5px 30px rgba(0, 0, 0, 0.3);
}

.close-btn {
  position: absolute;
  top: 15px;
  right: 20px;
  font-size: 28px;
  cursor: pointer;
  color: #666;
  z-index: 1010;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.05);
  transition: all 0.2s;
}

.close-btn:hover {
  color: #000;
  background-color: rgba(0, 0, 0, 0.1);
}

.article-content {
  margin-top: 20px;
  line-height: 1.6;
  white-space: pre-wrap;
  text-align: left;
  font-size: 16px;
}

@media (max-width: 768px) {
  .article-modal-content {
    padding: 30px 20px;
    width: 95%;
  }
}

.text-center {
  text-align: center;
}

.single-article-content {
  margin-top: 30px;
  line-height: 1.6;
  white-space: pre-wrap;
  text-align: left;
  font-size: 16px;
}
</style> 